import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Logo } from "../components/site/Logo";
import { CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError("Link non valido o scaduto. Richiedi un nuovo link di reimpostazione."); return; }
    if (form.password.length < 8) { setError("La password deve contenere almeno 8 caratteri"); return; }
    if (form.password !== form.confirm) { setError("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      setDone(true);
      toast.success("Password aggiornata");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Si è verificato un errore. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6" data-testid="reset-page">
      <div className="w-full max-w-md">
        <Logo />
        {done ? (
          <div data-testid="reset-done" className="mt-8 rounded-2xl border border-emerald-200 bg-emerald-50 p-6">
            <CheckCircle2 className="h-8 w-8 text-[#10B981]" />
            <h1 className="mt-4 font-display text-2xl font-bold text-[#0A192F]">Password aggiornata</h1>
            <p className="mt-2 text-sm text-slate-600">
              La tua password è stata reimpostata e tutte le sessioni precedenti sono state disconnesse. Ti stiamo portando alla pagina di accesso...
            </p>
            <Link to="/login" data-testid="reset-to-login" className="mt-6 inline-block font-semibold text-[#10B981]">Vai all'accesso</Link>
          </div>
        ) : (
          <>
            <h1 className="mt-8 font-display text-3xl font-bold text-[#0A192F]">Reimposta la password</h1>
            <p className="mt-2 text-slate-600">Scegli una nuova password per il tuo account ViviTranquillo.</p>

            {error && <div data-testid="reset-error" className="mt-6 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="mb-2 block text-sm font-semibold text-[#0A192F]">Nuova password</label>
                <input data-testid="reset-password" required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-[#10B981]" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-semibold text-[#0A192F]">Conferma password</label>
                <input data-testid="reset-confirm" required type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-[#10B981]" />
              </div>
              <button data-testid="reset-submit" disabled={loading} className="w-full rounded-full bg-[#10B981] px-8 py-3.5 font-semibold text-white transition-colors hover:bg-[#059669] disabled:opacity-60">
                {loading ? "Aggiornamento..." : "Aggiorna la password"}
              </button>
            </form>

            <p className="mt-6 text-center text-sm">
              <Link to="/login" className="text-slate-400 hover:text-[#0A192F]">← Torna all'accesso</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
